import { Modal } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import AntdConfirm from "../../helpers/AntdConfirm";
import { available_countries } from "../../helpers/GlobalOptions";
import { exportDocument } from "../../helpers/Utils";
import { deleteEnergyLabel } from "../../redux/Actions/energy_labels_action";
import { ButtonDelete, ButtonEdit, ButtonSmall } from "../common/Buttons";
import { IconEdit, IconPDF, IconSearch } from "../Layout/Icons";
import TableUi from "../Layout/TableUI";
import TableProductPreview from "../table/TableProductPreview";

const EnergyLabelColumn = ({
  id,
  energy_products,
  energy_documents,
  energy_class,
  eprel_id,
  setModalOpt,
}) => {
  const dispatch = useDispatch();
  const tableRef = useRef();
  const [open, setOpen] = useState(false);
  const tr_height = tableRef?.current?.clientHeight || 0;
  return (
    <tr ref={tableRef}>
      <TableUi.td className="p-left">
        <TableProductPreview
          autosys_products={energy_products}
          open={open}
          setOpen={setOpen}
        />
      </TableUi.td>
      <TableUi.td>{energy_class}</TableUi.td>
      <TableUi.td>{eprel_id}</TableUi.td>
      <TableUi.td className={"pt-0 pb-0"}>
        <div
          className="d-flex align-items-center"
          style={{
            borderRight: "1px solid #BFBFBF",
            borderLeft: "1px solid #BFBFBF",
            width: 600,
          }}
        >
          {available_countries.map((country) => (
            <div
              key={country.value}
              className="p-2"
              style={{
                width: 120,
                height: tr_height,
                minHeight: 89,
                backgroundColor: country.color,
              }}
            >
              {energy_documents
                .filter((d) => d.label_type == country.value)
                .map((d) => (
                  <div
                    className="d-flex align-items-center justify-content-between bg-white text-sm px-2 mb-2 cursor-pointer border-radius-3"
                    style={{
                      border: "1px solid #E0E0E0",
                      padding: "4px 5px 4px 4px",
                    }}
                    onClick={() => {
                      exportDocument(
                        `/api/v1/energy_documents/${d.id}/download`,
                        d?.asset?.url?.split("/")?.at(-1),
                        "POST"
                      );
                    }}
                  >
                    <div>
                      {d?.asset?.url?.split("/")?.at(-1) ?? "Something wrong"}
                    </div>
                    <IconPDF />
                  </div>
                ))}
            </div>
          ))}
        </div>
      </TableUi.td>
      <TableUi.td>
        {energy_documents
          .filter((d) => d.label_type == "label_image")
          .map((d) => (
            <LabelImagePreview {...d} />
          ))}
      </TableUi.td>
      <TableUi.td>
        <div className="d-flex justify-content-end flex-wrap">
          <ButtonSmall
            className="mb-1"
            onClick={() => {
              setModalOpt("update", id);
            }}
          >
            <IconEdit color="#fff" />
          </ButtonSmall>
          <div className="ml-1 mb-1">
            <ButtonDelete
              onDelete={() =>
                AntdConfirm({
                  onOk: () => {
                    dispatch(deleteEnergyLabel(id));
                  },
                })
              }
            />
          </div>
        </div>
      </TableUi.td>
    </tr>
  );
};

const LabelImagePreview = ({ asset, created_at, id }) => {
  const [previewImage, setPreviewImage] = useState(false);

  return (
    <div
      className="position-relative"
      onClick={() => setPreviewImage(!previewImage)}
      style={{
        width: 45,
        height: 90,
      }}
    >
      <div
        style={{
          backgroundImage: `url(${asset.url})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "100%",
        }}
      />

      <div
        className="position-absolute d-flex align-items-center justify-content-center cursor-pointer"
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(255, 255, 255, 0.9)",
          border: "1px solid #E0E0E0",
          borderRadius: 32,
          width: 30,
          height: 30,
        }}
      >
        <IconSearch color="#777777" />
      </div>
      {previewImage && (
        <Modal
          title={asset?.url?.split("/")?.at(-1) ?? "Something wrong"}
          visible={previewImage}
          okText="Download"
          onOk={() => {
            exportDocument(
              `/api/v1/energy_documents/${id}/download`,
              asset?.url?.split("/")?.at(-1),
              "POST"
            );
          }}
          onCancel={() => setPreviewImage(false)}
          width={1000}
          cancelText="Close"
        >
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-center" style={{ flex: 4 }}>
              <img className="img-fluid" src={asset.url} />
            </div>

            <div className="pl-2" style={{ flex: 1 }}>
              <ul>
                <li>
                  <span className="font-weight-bold">Title: </span>
                  {asset?.url?.split("/")?.at(-1) ?? "Something wrong"}
                </li>
                <hr />
                <li>
                  <span className="font-weight-bold">Format: </span>
                  {asset?.url?.split(".")?.at(-1) ?? "Something wrong"}
                </li>
                <hr />
                <li>
                  <span className="font-weight-bold">Uploaded document: </span>
                  {created_at.substr(0, 10)}
                </li>
              </ul>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default EnergyLabelColumn;
